import fetchTripDetails from './fetchTripDetails';

export default function fetchTripPath(tripId) {
  return fetchTripDetails(tripId, { include: ['path'] });
}
